import React, { useContext } from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { currencyDecimalMap } from "../../helper";
import { StateContext } from "../../store/context";
import { mergeBarChartOptions } from "../../pages/Compare/chartTheme";

// type orientationType = {
//   horizontal
// }
const EPSCurrenctVsPast: React.FC<any> = ({ data }): React.ReactElement => {
  const { series = [], categories = [] } = data || {};
  const { baseCurrency } = useContext(StateContext);

  const chartData: any = {
    options: mergeBarChartOptions({
      chart: {
        id: "EPSCurrentVsPast",
      },
      xaxis: {
        categories,
        labels: {
          rotate: 0,
        },
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            return (
              baseCurrency +
              " " +
              Number(value).toFixed(currencyDecimalMap[baseCurrency])
            );
          },
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        hideEmptySeries: false,
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        formatter: (value: string) => {
          return value
            ? Number(value).toFixed(currencyDecimalMap[baseCurrency])
            : "";
        },
      },
    }),
    chart: {
      type: "bar",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">EPS: Current-vs-Past (Quartely)</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={550}
      />
    </div>
  );
};

export default EPSCurrenctVsPast;
